import { TFunction } from "i18next";
import * as Yup from "yup";
import { PhoneNumberUtil } from "google-libphonenumber";
import { strictEmailRegex } from "@me-team/host/src/utils/utils";

const phoneUtil = PhoneNumberUtil.getInstance();

const isPhoneValid = (phone: string) => {
    try {
        return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone));
    } catch {
        return false;
    }
};

export const clientFormValidationSchema = (t: TFunction) =>
    Yup.object().shape({
        name: Yup.string().trim().required(t("validation.required")),
        email: Yup.string()
            .matches(strictEmailRegex, t("validation.requiredEmail"))
            .test(
                "email-required-if-no-phone",
                t("validation.at least one of the fields phone or email must be filled"),
                function (value) {
                    let phone = this.resolve(Yup.ref("phone"));
                    return phone ? true : !!value;
                }
            ),
        phone: Yup.string()
            .nullable()
            .transform((value) => (value === null ? "" : value))
            .test("phone-valid", t("Phone number is not valid"), function (value) {
                const trimmed = value?.trim() ?? "";
                if (trimmed === "") return true;

                const isOnlyDialCode = /^\+\d{1,4}$/.test(trimmed);
                if (isOnlyDialCode) return true;

                if (!isPhoneValid(trimmed)) {
                    return this.createError({ message: t("Phone number is not valid") });
                }
                return true;
            })
            .test(
                "phone-required-if-no-email",
                t("validation.at least one of the fields phone or email must be filled"),
                function (value) {
                    const email = this.resolve(Yup.ref("email"));
                    const trimmed = value?.trim() ?? "";
                    const isOnlyDialCode = /^\+\d{1,4}$/.test(trimmed);

                    if (trimmed === "" || isOnlyDialCode) {
                        return !!email;
                    }
                    return true;
                }
            ),
    });

export const clientFormValidationSchemaWithoutContacts = (t: TFunction) =>
    Yup.object().shape({
        name: Yup.string().trim().required(t("validation.required")),
        email: Yup.string().nullable(),
        phone: Yup.string().nullable(),
    });
